// Shared loading indicator: a CSS spinner + muted label. Styling is external
// CSS (styles.css .spinner / @keyframes spin), so it stays CSP-safe.
import { h } from '../core/dom';

export function loading(label = 'Loading…'): HTMLElement {
	return h(
		'div',
		{ class: 'loading' },
		h('span', { class: 'spinner', 'aria-hidden': 'true' }),
		h('span', { class: 'muted' }, label)
	);
}
